<template>
  <div>
    <button
      class="mr-2 btn"
      @click="emitTabChange('customer')"
      :class="buttonClass('customer')"
      target="customer"
    >
      {{ "customer" | t | titlecase }}
    </button>
    <button
      v-if="!thirdPartyManaged && customer.subscription"
      class="mr-2 btn"
      @click="emitTabChange('subscription')"
      :class="buttonClass('subscription')"
      target="subscription"
    >
      {{ "subscription" | t }}
    </button>
    <button
      v-if="!thirdPartyManaged"
      class="mr-2 btn"
      @click="emitTabChange('quote')"
      :class="buttonClass('quote')"
      target="quote"
    >
      {{ "quote" | t }}
    </button>
    <button
      v-if="can('write_customer_tokens')"
      class="mr-2 btn"
      @click="emitTabChange('users')"
      :class="buttonClass('users')"
      target="users"
    >
      {{ "users" | t }}
    </button>
    <button
      v-if="!thirdPartyManaged && can('read_change_logs')"
      class="mr-2 btn"
      @click="emitTabChange('changes')"
      :class="buttonClass('changes')"
      target="changes"
    >
      {{ "changes" | t }}
    </button>
    <button
      v-if="!thirdPartyManaged && customer.service_status == 'test'"
      class="mr-2 btn"
      @click="emitTabChange('reset')"
      :class="buttonClass('reset')"
      target="reset"
    >
      {{ "reset" | t | titlecase }}
    </button>
    <button
      v-if="!thirdPartyManaged && can('read_staff_accesses')"
      class="mr-2 btn"
      @click="emitTabChange('staff_accesses')"
      :class="buttonClass('staff_access')"
      target="staff_access"
    >
      {{ "staff_access" | t }}
    </button>
    <div class="mr-2 btn-group" v-if="!thirdPartyManaged">
      <button
        class="btn btn-outline-primary dropdown-toggle"
        id="billing-dropdown"
        href="#"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        {{ "billing" | t }}
      </button>
      <div class="dropdown-menu" aria-labelledby="billing-dropdown">
        <a
          v-for="tab in billingTabs"
          :key="tab"
          class="dropdown-item"
          @click="emitTabChange(tab)"
          :target="tab"
        >
          {{ tab | t | titlecase }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentTab: String,
    thirdPartyManaged: Boolean,
    customer: Object,
  },
  computed: {
    billingTabs() {
      return [
        "purchases",
        "discounts",
        "invoices",
        "payments",
        "events",
        "replaced_subscriptions",
      ];
    },
  },
  methods: {
    emitTabChange(tab) {
      this.$emit("tabChange", tab);
    },
    buttonClass(tab) {
      return this.currentTab === tab ? "btn-primary" : "btn-outline-primary";
    },
  },
};
</script>